const moment = require('moment');
const { BNPL_CURRENCY_USD, BNPL_DISABLED_REASON } = require('../constants/bnpl');

// days between "now" and the deal's free-cancellation deadline
function getDaysToDeadline(deal) {
    const deadline = deal && deal.dca && deal.dca.dealIsFullyRefundableTill;
    if (!deadline) return null;
    return moment.utc(deadline).startOf('day').diff(moment.utc().startOf('day'), 'days');
}

// The caller supplies surface-specific bnpl_shown, checkout_flow_variant, platform, and an optional
// bnpl_disabled_reason (both web and mobile already compute full-coverage in their components).
// When BNPL was actually used (usedBnpl), no disabled_reason applies. When eligible-but-unused with
// no explicit reason and no charge date, the deal's deadline was too close to defer payment.
function getBnplBookingProps({
    reservation,
    deal,
    bnpl_shown,
    checkout_flow_variant,
    platform,
    bnpl_disabled_reason = null,
    usedBnpl = false,
}) {
    if (!reservation) return {};
    const eligible = reservation.bnpl_eligible === true;
    let disabled_reason = null;
    if (usedBnpl) {
        disabled_reason = null;
    } else if (eligible) {
        if (bnpl_disabled_reason) {
            disabled_reason = bnpl_disabled_reason;
        } else if (!reservation.bnpl_charge_date) {
            disabled_reason = BNPL_DISABLED_REASON.DEADLINE_TOO_CLOSE;
        }
    }
    return {
        deferred_payment_fee_pct: reservation.bnpl_fee_percentage != null ? reservation.bnpl_fee_percentage : null,
        charge_date: reservation.bnpl_charge_date || null,
        bnpl_amount: reservation.bnpl_usd_amount_with_fee != null ? Number(reservation.bnpl_usd_amount_with_fee) : null,
        bnpl_currency: BNPL_CURRENCY_USD,
        bnpl_eligible: eligible,
        bnpl_shown: bnpl_shown === true,
        bnpl_disabled_reason: disabled_reason,
        checkout_flow_variant,
        platform,
        days_to_deadline: getDaysToDeadline(deal || reservation.deal),
    };
}

module.exports = {
    getBnplBookingProps,
    getDaysToDeadline,
};
